import React from "react";
import "./About.css";

const About = () => {
  return (
    <section id="about" className="about">
      <div className="about-bg-pattern" aria-hidden="true" />
      <div className="about-container">
        <header className="about-header">
          <span className="about-eyebrow">Who we are</span>
          <h2 className="about-title">About Us</h2>
          <div className="about-title-line" />
          <p className="about-intro">
            Crafting exceptional events with heart, precision, and a team that
            cares about every detail.
          </p>
        </header>

        <div className="about-body">
          <p className="about-lead">
            We are a professional Event Management Company, proudly serving
            the event industry since 2017. Over the years, we have successfully
            delivered a wide range of events including wedding planning,
            corporate events, and social events, earning the trust of our clients
            through quality execution and attention to detail.
          </p>
          <p>
            At our company, we believe that every successful event begins with
            proper research and detailed planning. Before executing any event, we
            thoroughly study the requirements, understand the client&apos;s
            vision, and create a well-structured plan to ensure smooth and
            flawless execution.
          </p>
          <p>
            We are backed by a team of experienced and skilled professionals
            who are dedicated to turning ideas into memorable experiences. Our
            staff works with passion, creativity, and precision to make sure
            your event is not just good—but the best it can be.
          </p>
          <p>
            From concept to completion, we focus on delivering innovative
            ideas, seamless coordination, and exceptional results, making your
            special moments truly unforgettable.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
